<template>
  <div id="app">
    <router-view ref="app"/>
  </div>
</template>
<script>
export default {
  mounted() {
    window.$vm = this.$refs.app;
  }
};
</script>
